import { render } from "./SplitDeliveries.vue?vue&type=template&id=ee058cf8&scoped=true"
import script from "./SplitDeliveries.vue?vue&type=script&lang=js"
export * from "./SplitDeliveries.vue?vue&type=script&lang=js"

import "./SplitDeliveries.vue?vue&type=style&index=0&id=ee058cf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee058cf8"]])

export default __exports__